var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStakeGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.949,
    height: 27.95,
    viewBox: "0 0 27.949 27.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_903",
    "data-name": "Grupo 903",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1557",
    "data-name": "Trazado 1557",
    d: "M20.215,8.32A8.233,8.233,0,0,0,19.3,24.736V25.7a.916.916,0,0,1-.915.915H3.745A.916.916,0,0,1,2.83,25.7V9.235H6.49A2.748,2.748,0,0,0,9.235,6.49V2.83h9.15a.916.916,0,0,1,.915.915V6.49a.915.915,0,0,0,1.83,0V3.745A2.748,2.748,0,0,0,18.385,1H8.32a.913.913,0,0,0-.648.269l-6.4,6.4A.924.924,0,0,0,1,8.32V25.7a2.748,2.748,0,0,0,2.745,2.745h14.64A2.748,2.748,0,0,0,21.13,25.7v-.969A8.233,8.233,0,0,0,20.215,8.32ZM7.4,4.124V6.49A.916.916,0,0,1,6.49,7.4H4.124ZM26.546,15.64H22.423l2.913-2.914A6.364,6.364,0,0,1,26.546,15.64Zm-6.332-5.49a6.359,6.359,0,0,1,3.828,1.282l-3.828,3.829-3.828-3.829A6.359,6.359,0,0,1,20.215,10.15Zm0,12.81a6.393,6.393,0,0,1-5.122-10.234L19.568,17.2a.926.926,0,0,0,.647.269h6.332A6.409,6.409,0,0,1,20.215,22.96Z",
    transform: "translate(-1 -1)",
    fill: "#fff",
    stroke: "#e73758",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1558",
    "data-name": "Trazado 1558",
    d: "M9.575,12H5.915a.915.915,0,1,0,0,1.83h3.66a.915.915,0,1,0,0-1.83Zm0,3.66H5.915a.915.915,0,1,0,0,1.83h3.66a.915.915,0,1,0,0-1.83Zm0,3.66H5.915a.915.915,0,1,0,0,1.83h3.66a.915.915,0,1,0,0-1.83Z",
    transform: "translate(-1.34 -1.935)",
    fill: "#fff",
    stroke: "#e73758",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeGraph);
export default __webpack_public_path__ + "static/media/stake-graph.249afaed9346abd2e80f75f2e1e288c5.svg";
export { ForwardRef as ReactComponent };